
import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { analyzeTaxHouseholdComposition } from '../../../../../../utils/householdMember/analyzeTaxHouseholdComposition';
import { getMarriageStatus } from '../../../../../../utils/householdMember/getMarriageStatus';
import { householdMemberTools } from '../../../../../../utils/tools/householdMemberTools';

// Constants

import { THC_TYPES } from '../../../../../../constants/ssap/hhmTypes/taxRelationsTypes';

const HouseholdInfo = props => {

    const {
        idx,
        personId,
        relations,
        serverDate,
        taxHousehold,
        taxHousehold: {
            bloodRelationship
        },
        taxHouseholdComposition: {
            taxFilingStatus,
            taxRelationship
        }
    } = props;

    const isMarried = getMarriageStatus(personId, bloodRelationship);

    const getIsFiler = taxRelationship => {
        return taxRelationship === THC_TYPES.FILER || taxRelationship === THC_TYPES.FILER_DEPENDENT;
    };

    const getIsFilingJointly = taxFilingStatus => {
        return taxFilingStatus === THC_TYPES.FILING_JOINTLY;
    };

    const isFiler = getIsFiler(taxRelationship);
    const isFilingJointly = getIsFilingJointly(taxFilingStatus);

    const getDependents = taxHousehold => {
        const family = analyzeTaxHouseholdComposition(
            taxHousehold.householdMember,
            relations,
            taxHousehold.bloodRelationship,
            serverDate,
            taxHousehold.primaryTaxFilerPersonId
        );

        return family
            .dependents
            .filter(d => d.isDependent)
            .reduce((claimedDependents, { claimerIds, dependentFullName }) => {
                return claimerIds.includes(personId)
                    ? [ ...claimedDependents, dependentFullName ]
                    : claimedDependents;
            }, []);
    };

    const getDependentsNames = data => {
        const dependents = getDependents(data);

        return dependents.length > 1
            ? dependents.join(', ')
            : dependents.toString();
    };

    const getPtfName = taxHousehold => {
        const {
            householdMember,
            primaryTaxFilerPersonId: ptfPersonId
        } = taxHousehold;

        if (ptfPersonId) {
            return householdMemberTools
                .extractFromHouseholdMembers(householdMember)
                .getFullNameByHhmId(ptfPersonId);
        } else {
            return null;
        }
    };

    const ptfName = getPtfName(taxHousehold);

    return (
        <Fragment>

            <SummaryItem
                textCode = 'common.planning_to_file'
                value = { isFiler }
                desc = {
                    [
                        [
                            `taxHousehold.householdMember[${ idx }].taxHouseholdComposition.taxRelationship`,
                            getIsFiler
                        ]
                    ]
                }
            />
            {
                isMarried &&
                    <SummaryItem
                        textCode = 'common.household_filing_jointly'
                        value = { isFilingJointly }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].taxHouseholdComposition.taxFilingStatus`,
                                    getIsFilingJointly
                                ]
                            ]
                        }
                    />
            }

            {
                ptfName
                    ? (
                        <SummaryItem
                            textCode = 'common.who_is_ptf'
                            value = { ptfName }
                            ignoreIntl
                            desc = {
                                [
                                    [
                                        [
                                            'DATA.TAX_HOUSEHOLD'
                                        ],
                                        getPtfName
                                    ]
                                ]
                            }
                        />
                    )
                    : null
            }

            {
                isFiler && !!getDependents(taxHousehold).length &&

                <SummaryItem
                    textCode = {
                        getDependents(taxHousehold).length > 1
                            ? 'common.household_dependants_claimed'
                            : 'common.household_dependant_claimed'
                    }
                    value = { getDependentsNames(taxHousehold) }
                    ignoreIntl
                    desc = {
                        [
                            [
                                [
                                    'DATA.TAX_HOUSEHOLD'
                                ],
                                getDependentsNames
                            ]
                        ]
                    }
                />
            }

        </Fragment>
    );
};

export default HouseholdInfo;